import { Grid } from "@mui/material";
import { useTicker } from "../../hooks/useTicker";
import TickerCell from "../TickerCell/TickerCell";
import { TickerSeparator } from "../TickerSeparator/TickerSeparator";

export const Ticker = ({ futureDate }) => {
  const { days, hours, minutes, seconds, isTimeUp } = useTicker(futureDate);
  const tickerContents = isTimeUp ? (
    <div className={"style.timeIsUp"}>Pre-Sale I is here</div>
  ) : (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={3}>
        <TickerCell value={days} label="Days" />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TickerCell value={hours} label="Hours" />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TickerCell value={minutes} label="Minutes" />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TickerCell value={seconds} label="Seconds" />
      </Grid>
    </Grid>
  );

  return <div className={"style.tickerShell "}>{tickerContents}</div>;
};
